<template>
  <div class="sm:border-b sm:border-gray-400 sm:pb-5 mb-5">
    <h3 class="text-lg leading-6 font-semibold text-blue-600">
      {{ title || 'Manage Media' }}
    </h3>
    <p class="mt-1 max-w-2xl text-sm text-gray-600">
      Upload photos, galleries, and videos that will sync with your ecommerce and point-of-sale.
    </p>
  </div>

  <media-library-attachment />
</template>

<script>
import { MediaLibraryAttachment } from 'media-library-pro-vue3-attachment'

export default {
  name: 'media-form',
  components: { MediaLibraryAttachment },
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>
